import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { LocationsRepository } from "../../repositories";
import { Location } from "../../domain/models";
import { PrivateLocationRequest } from "../../domain/requests";
import { GetPrivateLocationsResponse } from "../../domain/models/get-private-location.model";

@Injectable({providedIn: 'root'})
export class GetPrivateLocationsUsecase implements UseCase<PrivateLocationRequest, GetPrivateLocationsResponse> {
  constructor(private locationRepository: LocationsRepository) {
  }

  execute(request: PrivateLocationRequest): Observable<GetPrivateLocationsResponse> {
    return this.locationRepository.getPrivateLocations(request);
  }
}
